var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 23,
    viewBox: "0 0 13 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3963 1.44763L11.3761 1.44769L11.356 1.44936C11.2044 1.462 11.0568 1.50625 10.923 1.57952C10.8006 1.64657 10.6923 1.73644 10.604 1.84408L1.22402 11.2241L1.22398 11.224L1.2189 11.2293C1.01766 11.4365 0.905158 11.714 0.905158 12.0027C0.905158 12.2915 1.01774 12.5689 1.2189 12.776L1.21886 12.776L1.22402 12.7812L10.624 22.1812L10.624 22.1812L10.6292 22.1863C10.8365 22.3876 11.1139 22.5 11.4026 22.5C11.6912 22.5 11.9687 22.3876 12.1759 22.1863L12.1812 22.1812L12.1862 22.176C12.3875 21.9688 12.5 21.6913 12.5 21.4026C12.5 21.1137 12.3874 20.8364 12.1862 20.6293L12.1863 20.6293L12.1811 20.6241L3.53468 11.9777L12.1811 3.33121L12.1812 3.33125L12.1862 3.32602C12.3875 3.11884 12.5 2.84136 12.5 2.55261C12.5 2.26376 12.3874 1.98643 12.1862 1.77933L12.1846 1.77769C12.0821 1.67307 11.9595 1.58971 11.8238 1.53292C11.6884 1.4762 11.543 1.44726 11.3963 1.44763Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.ece36f66d7e69175229a921ed6529c17.svg";
export { ForwardRef as ReactComponent };